import {Header} from "../components/Header";
import {Group} from '@mantine/core';
import {ENATextSection} from "../components/ENATextSection";
import {ENANav} from "../components/ENANav";
import {TableOfContents} from "../components/TableOfContents";

const ENAPage = () => {
    return (
        <>
            <Header/>
            <Group style={{
                display: 'flex',
                justifyContent: 'space-between'
            }}
                   align="flex-start"
                   justify="space-between"
                   wrap="nowrap"
                   gap="xl"
            >
                <TableOfContents/>
                <ENATextSection/>
                <ENANav/>
            </Group>
        </>
    )
}

export default ENAPage;